<lvr-nav-carousel
	backLabel="Zurück"
	[backLink]="backLink()"
	[carouselElements]="carouselElements()"
	[initialIndex]="currentIndex()"
	(navigation)="onNavigate($event)"
></lvr-nav-carousel>

<div class="header">
	<h2>{{ templateName() }}</h2>
	<div class="actions-row">
		<!-- Print -->
		<lvr-button
			variant="primary"
			[label]="'base.button.print' | transloco"
			[loadingLabel]="'base.button.generating_pdf' | transloco"
			[type]="'button'"
			[loading]="isPrinting()"
			(clicked)="print()"
			icon="print"
		></lvr-button>

		<!-- Export -->
		<lvr-button
			variant="primary"
			[label]="'base.button.export' | transloco"
			[loadingLabel]="'base.button.export_pdf' | transloco"
			[type]="'button'"
			[loading]="isProcessing()"
			(clicked)="export()"
			icon="ios_share"
		></lvr-button>
	</div>
</div>

<lvr-html-editor [html]="templateHtmlContent()" [readOnly]="false" (docChange)="onDocChange($event)"></lvr-html-editor>
